import { render, staticRenderFns } from "./cadastroPj.vue?vue&type=template&id=021e9243&"
import script from "./cadastroPj.vue?vue&type=script&lang=js&"
export * from "./cadastroPj.vue?vue&type=script&lang=js&"
import style0 from "./cadastroPj.vue?vue&type=style&index=0&id=021e9243&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports